import VersionTooltipContent from "components/FormFields/VersionInput/VersionTooltipContent";
import FormFieldViewBoolean from "components/FormFields/ViewBoolean";
import FormFieldViewText from "components/FormFields/ViewText";
import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import { VENDOR_DICTIONARY } from "constants/vendor";
import TooltipModalBody from "ds/components/TooltipModal/Body";
import { TooltipModalTitle } from "ds/components/TooltipModal/Title";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";

import StackSettingsViewVendorFormField from "../../components/ViewVendorFormField";
import { StackSettingsContextData } from "../../Context";
import SettingsNewVendorViewVersion from "../components/ViewVersion";
import {
  getConciseTooltip,
  getEnableCPUProfilingTooltip,
  getExternalStateAccessEnabledTooltip,
  getWorkflowToolTooltip,
} from "./getTooltips";
import { OpenTofuVendorConfig, workflowToolLabel } from "./helpers";

const StackSettingsVendorOpenTofuView = () => {
  const { stackSettings } = useTypedContext(StackSettingsContextData);
  const config = stackSettings.vendorConfig as unknown as OpenTofuVendorConfig;

  return (
    <>
      <StackSettingsViewVendorFormField vendorName={VENDOR_DICTIONARY.OPEN_TOFU} />
      <FormFieldViewText
        label="Workflow tool"
        value={workflowToolLabel(config.openTofuWorkflowTool)}
        {...getWorkflowToolTooltip()}
        noMargin
      />
      {config.version && (
        <SettingsNewVendorViewVersion
          label="Version"
          version={config.version}
          versionTooltip={
            <>
              <TooltipModalTitle>Version</TooltipModalTitle>
              <TooltipModalBody align="start">
                <VersionTooltipContent />
                <ReadMoreDocsLink
                  docsUrl={getDocsUrl(
                    "/concepts/stack/stack-settings#opentofuterraform-specific-settings"
                  )}
                />
              </TooltipModalBody>
            </>
          }
          effectiveVersion={stackSettings.effectiveTerraformVersion}
          effectiveVersionTooltip={
            "When the OpenTofu version is a version range, this is the highest version in the range that will be used for the next run."
          }
        />
      )}
      <FormFieldViewBoolean
        label="Smart sanitization"
        value={config.useSmartSanitization}
        noMargin
      />
      <FormFieldViewBoolean
        label="Concise output"
        value={config.concise}
        {...getConciseTooltip()}
        noMargin
      />
      <FormFieldViewBoolean
        label="CPU profiling"
        value={config.enableCPUProfiling}
        {...getEnableCPUProfilingTooltip()}
        noMargin
      />
      <FormFieldViewBoolean
        label="Manage state"
        value={stackSettings.managesStateFile}
        {...getExternalStateAccessEnabledTooltip()}
        noMargin
      />
      {stackSettings.managesStateFile && (
        <FormFieldViewText label="Workspace" value={config.workspace} noMargin />
      )}
    </>
  );
};

export default StackSettingsVendorOpenTofuView;
